import { connect } from 'react-redux'

import * as UserSelectors from 'modules/user/selectors'

import VideoSuccessStep from './component'

const mapStateToProps = state => ({
  name: UserSelectors.getName(state),
})

export default connect(mapStateToProps)(VideoSuccessStep)



// WEBPACK FOOTER //
// ./src/layouts/VideoSuccessStep/index.js